import React, { useContext, useEffect, useState } from 'react'
import SidebarContext from '../../../contexts/MyContext';
import SettingHandler from '../../../Apihander/setting/settingHandler';
import { successToast } from '../../../utils/notificationUtils';
import { Icon } from "@iconify/react/dist/iconify.js";

const DefaultAudioFormat = () => {
  const { user, setUser, selectedFormat, setSelectedFormat } = useContext(SidebarContext);
  const [loading, setLoading] = useState(false);
  const [initialFormat, setInitialFormat] = useState(user?.selectedFormat); // To track the initial format



  // Set initial format when the component mounts or the user changes
  useEffect(() => {

    // setInitialFormat(user?.selectedFormat);
    setSelectedFormat(user?.audioFormat == 'caf' || user?.audioFormat == 'm4a' ? "mp3" : user?.audioFormat); // Reset to backend format when unmounting
    // console.log();
    // return () => {
    // };

  }, [user]);

  const handleFormatChange = (value, event) => {
    setSelectedFormat(value)
  }

  const handleFormateUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {

      const payload = {
        audioFormat: selectedFormat
      }
      const Response = await SettingHandler.doHandlerSetting(payload)
      successToast(Response?.message || "Audio format updated successfully")
      // Update the user object locally and in the context
      const updatedUser = {
        ...user,
        audioFormat: selectedFormat,
      };

      // Update local storage
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));

      // Update the context (so the app reflects the new user data)
      setUser(updatedUser);

      // Update the initial format to the newly selected one
      setInitialFormat(selectedFormat);
    } catch (error) {
      console.log("🚀 ~ handleFormatChange ~ error:", error)
    }
    finally {
      setLoading(false);
    }
  }


  return (
    <div className='vr-set-page'>
      <h2 className="vr-set-title">
        Default Audio Format
      </h2>
      <div className='vr-set-card'>
        <div className='vr-set-options'>
            <div className={`vr-set-option ${selectedFormat === "mp3" ? 'is-selected' : ''}`}
              role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
              onClick={(e) => {
                handleFormatChange("mp3", e);
              }}
            >
              <div className="form-check">
                <span className="vr-set-option-icon"><Icon icon="lucide:file-audio" width="18" height="18" /></span>
                <label className="form-check-label vr-set-option-title" htmlFor="mp3Radio">
                  mp3
                </label>
                <input
                  className="form-check-input"
                  type="radio"
                  name="audioFormat"
                  id="mp3Radio"
                  value="mp3"
                  checked={selectedFormat === "mp3"}
                  readOnly

                />
              </div>
            </div>

          {/* <div className='col-sm-12 col-md-6 col-lg-6'>
            <div style={{
              padding: "10px 20px 10px 20px",
              border: "1.5px solid #F1F5F9",
              color: '#64748B',
              cursor: 'pointer',
              borderRadius: "8px",
              marginBottom: '20px'


            }}
              onClick={(e) => {
                handleFormatChange("m4a", e);
              }}>
              <div
                className="form-check d-flex justify-content-between align-items-center"
                style={{
                  paddingLeft: '0px',
                  cursor: 'pointer'
                }}

              >
                <label className="form-check-label" htmlFor="m4aRadio"
                  style={{ cursor: 'pointer' fontFamily:'Metropolis', fontWeight:'500', fontSize:'16px', color:'#334155' }}
                >
                  m4a
                </label>
                <input
                  className="form-check-input"
                  type="radio"
                  name="audioFormat"
                  id="m4aRadio"
                  value="m4a"
                  checked={selectedFormat === "m4a"}
                  style={{ cursor: 'pointer' }}

                />
              </div>
            </div>
          </div> */}
          {/* <div className='col-sm-12 col-md-6 col-lg-6'>
            <div style={{
              padding: "10px 20px 10px 20px",
              border: "1.5px solid #F1F5F9",
              color: '#64748B',
              cursor: 'pointer',
              borderRadius: "8px",
              marginBottom: '20px'
            }}
              onClick={(e) => {
                handleFormatChange("caf", e);
              }}>
              <div
                className="form-check d-flex justify-content-between align-items-center"
                style={{
                  paddingLeft: '0px',
                  cursor: 'pointer'
                }}

              >
                <label className="form-check-label" htmlFor="cafRadio"
                  style={{ cursor: 'pointer', fontFamily:'Metropolis', fontWeight:'500', fontSize:'16px', color:'#334155' }}
                >
                  caf
                </label>
                <input
                  className="form-check-input"
                  type="radio"
                  name="audioFormat"
                  id="cafRadio"
                  value="caf"
                  checked={selectedFormat === "caf"}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          </div> */}
            <div className={`vr-set-option ${selectedFormat === "wav" ? 'is-selected' : ''}`}
              role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
              onClick={(e) => {
                handleFormatChange("wav", e);
              }}>
              <div className="form-check">
                <span className="vr-set-option-icon"><Icon icon="lucide:audio-waveform" width="18" height="18" /></span>
                <label className="form-check-label vr-set-option-title" htmlFor="wavRadio">
                  wav
                </label>
                <input
                  className="form-check-input"
                  type="radio"
                  name="audioFormat"
                  id="wavRadio"
                  value="wav"
                  checked={selectedFormat === "wav"}
                />
              </div>
            </div>
        </div>
          <div className="form-group vr-set-actions">
            <button
              type="submit"
              className="vr-btn vr-btn-primary vr-btn-lg"
              disabled={loading || user?.audioFormat === selectedFormat}
              style={{ cursor: loading || user?.audioFormat === selectedFormat ? 'not-allowed' : 'pointer' }}
              onClick={(e) => {
                if (!loading) {
                  handleFormateUpdate(e);
                }
              }}
            >

              {loading ? (
                <>
                  <span style={{ marginRight: '10px' }}>Loging in</span>

                  <div
                    className="spinner-border vr-set-spin"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </>
              ) : (
                <>
                  <span>
                    Save
                  </span>
                </>
              )
              }
            </button>
          </div>
      </div>
    </div>
  )
}

export default DefaultAudioFormat
